<template>
  <div>
    <el-card>
      <div class="blocked_logs_page">
    <h1>匹配行为数据</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="language"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
      </el-select>
       <el-select
        style="width: 160px"
        v-model="country"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="userType"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in userTypes"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
     
      <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      <el-button type="primary" @click="get_list" :loading="login1">查询</el-button>
      <el-button type="primary" @click="dwnDayChatDetai">下载</el-button>
    </div>
    <el-row>
      <el-table
        :data="tableList"
        border
        
        v-loading="login1"
      >
        <el-table-column align="center" fixed prop="date" label="日期"   sortable>
        </el-table-column>
        <el-table-column align="center" prop="dau" label="活跃人数"   sortable>
        </el-table-column>
         <el-table-column align="center" prop="matchSuccessCount" label="匹配成功次数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchSuccessUser" label="匹配成功人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchRealCount" label="匹配真实主播次数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchRealUser" label="匹配真实主播人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchRealSuccessCount" label="匹配真实主播成功次数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchRealSuccessUser" label="匹配真实主播成功人数"  sortable>
        </el-table-column>
         <el-table-column align="center" prop="matchRealRechargeCount" label="匹配真实主播充值成功次数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchRealRechargeUser" label="匹配真实主播充值成功人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchRealAvgCallTime" label="匹配真实主播平均通话时长"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchFakeCount" label="匹配假视频次数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchFakeUser" label="匹配假视频人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchFakeSuccessCount" label="匹配假视频通话成功次数"  sortable>
        </el-table-column>
         <el-table-column align="center" prop="matchFakeSuccessUser" label="匹配假视频通话成功人数"  sortable>
        </el-table-column>
         <el-table-column align="center" prop="matchFakeRechargeCount" label="匹配假视频充值成功次数"  sortable>
        </el-table-column>
         <el-table-column align="center" prop="matchFakeRechargeUser" label="匹配假视频充值成功人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchFakeAvgCallTime" label="匹配假视频平均通话时长"   sortable>
        </el-table-column>
        
        
        
        
        
        
        
       
        
        
       
      </el-table>
    </el-row>
      <!-- <el-row >
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="30"
      ></el-pagination>
    </el-row> -->
      </div>
    </el-card>
    <el-card>
    <FakeCallDuration></FakeCallDuration>
    </el-card>
    <el-card>
    <RealCallDuration></RealCallDuration>
    </el-card>
  </div>
</template>

<script>
import download from '@/utils/download.js'
import FakeCallDuration from './action_/fakeCallDuration'
import RealCallDuration from './action_/realCallDuration'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  components: {
    FakeCallDuration,
    RealCallDuration
  },
  data() {
    return {
      login1: false,
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      platformData: [datainfor(2), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      loading: true,
      language: 'total',
      languageList: '',
      country: 'total',
      countryList: '',
      userType: -1,
      userTypes: [
        {
          label: 'total',
          value: -1
        },
        {
          label: '新用户',
          value: 1
        },
        {
          label: '老用户',
          value: 0
        }
      ],
      page: 1,
      total: 0
    }
  },
  beforeCreate() {},
  created() {
    this.languages()
    this.getCountry_()
    this.get_list()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    async languages() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
      }
    },
    async getCountry_() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async get_list() {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_match_action,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          userType: this.userType
        }
      })
      if (res !== null) {
        this.login1 = false
        this.tableList = res.data.data
        this.total = res.data.total
      }
    },
    // 分页
    handleCurrentChange(num) {
      this.page = num
      this.get_list()
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_match_action_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          userType: this.userType
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(
        res.data,
        '匹配行为数据' + (this.platformData[0] + '-' + this.platformData[1])
      )
    }
  }
}
</script>


<style lang="stylus" scoped>
.el-card {
  margin: 0 0 20px;
}
.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
